import { IModelEntity } from '@pit/core';

export interface IDtoLocation extends IModelEntity {

    deviceId?: string;

    accuracy?: number;
    latitude?: number;
    longitude?: number;
    timestamp?: Date;

}
